import { AiOutlineDashboard } from 'react-icons/ai'
import { FaHandHoldingUsd, FaHandshake } from 'react-icons/fa'
import { GiSettingsKnobs } from 'react-icons/gi'
import { HiOutlinePresentationChartLine } from 'react-icons/hi'
import { RiStore2Line } from 'react-icons/ri'

import type { ILink } from '@base/@types/components/Layout/Navigator'

const budgetLinks: ILink = {
  group: 'Orçamento',
  icon: <AiOutlineDashboard />,
  roles: ['OTB'],
  menu: [
    {
      name: 'Relátorio',
      path: '/orcamento/relatorio',
      icon: <HiOutlinePresentationChartLine />,
      description: 'Consolidação dos orçamentos definidos',
      roles: ['Administrador', 'Financeiro', 'AnalistaPlanejamento']
    },
    {
      name: 'Parâmetros',
      path: '/orcamento/parametros',
      icon: <GiSettingsKnobs />,
      description: 'Parâmetros para o orçamento ',
      roles: ['Administrador', 'Financeiro', 'AnalistaPlanejamento']
    },
    {
      name: 'Comercial',
      path: '/orcamento/comercial',
      icon: <FaHandHoldingUsd />,
      description: 'Orçamento com visão comercial ',
      roles: ['Administrador', 'Financeiro', 'AnalistaPlanejamento']
    },
    {
      name: 'Lojas',
      path: '/orcamento/lojas',
      icon: <RiStore2Line />,
      description: 'Orçamento com visão de operações ',
      roles: ['Administrador', 'Financeiro', 'AnalistaPlanejamento']
    },
    {
      name: 'Conciliação',
      path: '/orcamento/conciliacao',
      icon: <FaHandshake />,
      colSpan: 2,
      description: ' Conciliação de orçamentos comercial e operações ',
      roles: ['Administrador', 'Financeiro', 'AnalistaPlanejamento']
    }
  ]
}

export default budgetLinks
